<script>
import NumberFormatter from "@/components/utility/number-formatter.vue";
import axios from "axios";
import {appConfig} from '../../config';
import { mapGetters } from 'vuex'
export default {
  name: 'modal-add-credits',
  components: {NumberFormatter},
  props: {
    hideFooter: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      showDialog: false,
      creditQty:{
          daDollarsStandard: 5,
          daNtarltarStandard: 5,
          piPartIdentification: 80,
          viVehicleIdentification: 80,
      },
      cartQty:{
        daDollarsStandard:0,
        daNtarltarStandard:0,
        piPartIdentification:0,
        viVehicleIdentification:0,
      },
      stepModal: 0,
      selectedPaymentMethod: 'new-card', // 'new-card' or 'saved-card'
      saveCard: false,
      disabled: false,
      stripe: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      totalAmount: 0, // This should be calculated based on selected credits
      editingCartKey: null,
      selectedCardId: null,
      statusPaid:false,
      stripeErrorText:'',
      cardToDelete: null,
    }
  },
  computed: {
    ...mapGetters({
      isAiCopilotDamageDisabled: 'isAiCopilotDamageDisabled',
      isAiCopilotPartsInfoDisabled: 'isAiCopilotPartsInfoDisabled',
      isAiCopilotVehicleDisabled: 'isAiCopilotVehicleDisabled',
      getSavedCards: 'getSavedCards',
      isPremiumPlan:'isPremiumPlan'
    }),
    stripeCards() {
      return this.getSavedCards || [];
    },

    // Replace local hasSavedCard with computed from store
    hasSavedCards() {
      return this.stripeCards && this.stripeCards.length > 0;
    },

    // Get selected card object from store
    selectedCard() {
      if (!this.selectedCardId || !this.stripeCards) return null;
      return this.stripeCards.find(card => card.payment_method_id === this.selectedCardId);
    },
    defaultCard() {
      if (!this.stripeCards || this.stripeCards.length === 0) return null;
      return this.stripeCards.find(card => card.is_default) || this.stripeCards[0];
    },
    subtotal(){
      const sum = (this.cartQty.daDollarsStandard * 5.00 + this.cartQty.daNtarltarStandard * 5.00 + this.cartQty.piPartIdentification * 0.10 + this.cartQty.viVehicleIdentification * 0.30);
      return this.roundToTwo(sum);
    },
    gst(){
      const gstValue = Number(this.subtotal) * 0.1;
      return this.roundToTwo(gstValue);
    },
    total(){
       const subtotalNum = Number(this.subtotal);
       if (!Number.isFinite(subtotalNum)) {
         return '0.00';
       }
       if (subtotalNum === 0) {
         return this.roundToTwo(subtotalNum);
       }
       return this.roundToTwo(subtotalNum * 1.1);
    }
  },
  methods: {
    confirmRemoveSavedCard(paymentMethodId) {
      if (confirm('Are you sure you want to remove this saved card? This action cannot be undone.')) {
        this.removeSavedCard(paymentMethodId);
      }
    },
    useSavedCard(paymentMethodId) {
      this.selectedCardId = paymentMethodId;
      this.selectedPaymentMethod = 'saved-card';
      // Clean up Stripe elements when using saved card
      this.cleanupStripeElements();
    },
    setDefaultCard(paymentMethodId) {
      this.stripeCards.forEach(card => {
        const isSelected = card.payment_method_id === paymentMethodId;
        card.is_default = isSelected;
      });
    },
    onCartQtyChange(key) {
      const num = Number(this.cartQty[key]);
      this.cartQty[key] = Number.isFinite(num) ? num : 0;
    },
    onCartFocus(key) {
      this.editingCartKey = key;
    },
    onCartBlur() {
      this.editingCartKey = null;
    },
    shouldShowCartItem(key) {
      if (this.editingCartKey === key) return true;
      const num = Number(this.cartQty[key]);
      return Number.isFinite(num) && num > 0;
    },
    roundToTwo(value) {
      const num = Number(value);
      return Number.isFinite(num) ? num.toFixed(2) : '0.00';
    },
    truncate2Str(value) {
      if (value == null || isNaN(value)) {
      return '0.00';
      }
      return (Math.floor(value * 100) / 100).toFixed(2);
    },

    async removeSavedCard(paymentMethodId) {
      try {
        const response = await axios.post('/fe/credits/remove-saved-card', {
          paymentMethodId
        });

        if (response.data._status) {
          // Dispatch to Vuex to update store
          this.$store.commit('removeStripeCard', paymentMethodId);

          // Clear selection if removing selected card
          if (this.selectedCardId === paymentMethodId) {
            this.selectedCardId = null;
          }

          toastr.success('Card removed successfully');
        }
      } catch (error) {
        console.error('Error removing saved card:', error);
        toastr.error('Error removing card');
      }
    },

    async processPayment() {
      this.clearCardError();
      if (this.selectedPaymentMethod === 'new-card') {
        await this.processNewCardPayment();
      } else {
        await this.processSavedCardPayment();
      }
    },

    async processNewCardPayment() {
      toastr.info('Processing your payment...');
      this.disabled = true;

      try {
        // Get payment intent from backend
        const response = await axios.post('/fe/credits/stripe-get-intent', {
          sum: this.total,
          cart: this.cartQty,
          saveCard: this.saveCard
        });

        if (!response.data._status) {
          this.disabled = false;
          toastr.error('Cannot get payment intent!');
          return;
        }

        const paymentId = response.data.paymentId;

        // Create token from card
        const { token, error } = await this.stripe.createToken(this.cardNumber);
        if (error) {
          this.disabled = false;
          document.getElementById('card-error').innerHTML = error.message;
          return;
        }

        // Process token
        const processResponse = await axios.post('/fe/credits/stripe-token-processing', {
          token,
          paymentId,
          saveCard: this.saveCard
        });

        if (!processResponse.data._status) {
          this.disabled = false;
          toastr.error('Cannot process your payment!');
          return;
        }

        // Confirm payment
        const { paymentIntent, error: intentError } = await this.stripe.retrievePaymentIntent(processResponse.data.intent.client_secret);
        if (intentError) {
          this.disabled = false;
          document.getElementById('card-error').innerHTML = intentError.message;
          this.viewStatusPay(false,intentError.message);
          return;
        }

        // Confirm card payment
        this.stripe.confirmCardPayment(paymentIntent.client_secret)
            .then(response => {
              if (response.error) {
                console.log('error', response.error);
                // Report Stripe error details for AI credits
                axios.post('/fe/ai-credits/stripe-error', {
                  error: response.error
                }).catch(err => console.error('Failed to log Stripe error', err));
                this.disabled = false;
                document.getElementById('card-error').innerHTML = response.error.message;

                this.viewStatusPay(false,response.error.message);
                // toastr.error(response.error.message);
                return;
              }

              // Final confirmation
              axios.post('/fe/credits/stripe-confirm', { paymentId })
                  .then(response => {
                    if (response.data?._status) {
                      toastr.success('Payment successful!');
                      this.disabled = false;
                      this.viewStatusPay(true);
                      this.$emit('credits-purchased', {
                        amount: this.total
                      });
                    } else {
                      this.viewStatusPay(false);
                      toastr.error('Payment failed!');
                    }
                  })
                  .catch(e => {
                    this.viewStatusPay(false);
                    console.error(e)})
                  .finally(() => {
                    this.disabled = false;
                  });
            })
            .catch(e => console.log(e));

      } catch (error) {
        console.error('Payment processing error:', error);
        this.disabled = false;
        this.viewStatusPay(false);
        toastr.error('Payment processing failed');
      }
    },
    async processSavedCardPayment() {
      const selectedCard = this.selectedCard;
      if (!selectedCard) {
        toastr.error('Please select a saved card');
        return;
      }

      toastr.info('Processing your payment...');
      this.disabled = true;
      try {
        // Get payment intent for saved card
        const response = await axios.post('/fe/credits/stripe-get-intent', {
          sum: this.total,
          cart: this.cartQty,
          paymentMethodId: this.selectedCard.payment_method_id
        });

        if (!response.data._status) {
          this.disabled = false;
          toastr.error('Cannot get payment intent!');
          return;
        }
        console.log('resp check',response)
        const paymentId = response.data.paymentId;

// Check if payment was already confirmed on the server (saved card with confirm: true)
        if (response.data.confirmed === true) {
          // Payment already succeeded, skip client-side confirmation
          // Proceed directly to finalize
          this._finalizePayment(paymentId);
          return;
        }
        if (response.data.requiresAction === true) {
          const { error, paymentIntent } = await this.stripe.handleNextAction({
            clientSecret: response.data.intent.client_secret
          });

          if (error) {
            console.log('error', error);
            // Report Stripe error details for AI credits
            axios.post('/fe/ai-credits/stripe-error', {
              error
            }).catch(err => console.error('Failed to log Stripe error', err));
            this.disabled = false;
            toastr.error(error.message);
            return;
          }

          // After handling action, finalize payment
          this._finalizePayment(paymentId);
          return;
        }
        // Fallback: If not confirmed and no action required, try to confirm
        // (This handles edge cases where backend didn't set confirm: true)
        this.stripe.confirmCardPayment(response.data.intent.client_secret)
            .then(confirmResponse => {
              if (confirmResponse.error) {
                console.log('error', confirmResponse.error);
                // Report Stripe error details for AI credits
                axios.post('/fe/ai-credits/stripe-error', {
                  error: confirmResponse.error
                }).catch(err => console.error('Failed to log Stripe error', err));
                this.disabled = false;
                toastr.error(confirmResponse.error.message);
                return;
              }

              // Final confirmation
              this._finalizePayment(paymentId);
            })
            .catch(e => console.log(e));

      } catch (error) {
        console.error('Saved card payment error:', error);
        this.disabled = false;
        this.viewStatusPay(false);
        toastr.error('Payment processing failed');
      }
    },
    _finalizePayment(paymentId) {
      axios.post('/fe/credits/stripe-confirm', { paymentId })
          .then(response => {
            if (response.data?._status) {
              toastr.success('Payment successful!');
              this.disabled = false;
              this.viewStatusPay(true);
              this.$emit('credits-purchased', {
                amount: this.total
              });
            } else {
              this.viewStatusPay(false);
              toastr.error('Payment failed!');
            }
          })
          .catch(e => {
            this.viewStatusPay(false);
            console.error(e);
          })
          .finally(() => {
            this.disabled = false;
          });
    },
    show: function () {
      this.showDialog = true;
      // Initialize Stripe after modal is shown
      this.$nextTick(() => {
        if (this.selectedPaymentMethod === 'new-card') {
          this.initializeStripe();
        }
      });
    },
    viewStatusPay(status,errorMessage = null) {
      this.stripeErrorText = errorMessage
      this.statusPaid = status;
      this.stepModal = 1;
      setTimeout(() => {
        if (status) {
          this.clearCardError();
          this.cleanupStripeElements();
          this.showDialog = false;
          this.stepModal = 0;
          this.cartQty.daDollarsStandard = 0
          this.cartQty.daNtarltarStandard = 0
          this.cartQty.piPartIdentification = 0
          this.cartQty.viVehicleIdentification = 0
        } else {
          this.stepModal = 0;
        }
      }, 4000);
    },
    hide: function () {
      this.clearCardError();
      this.showDialog = false;
      this.stripeErrorText = '';
    },
    addToCart(type){
      this.cartQty[type] += parseInt(this.creditQty[type]);
      // this.creditQty[type] = 1;
    },
    // Stripe related methods
    initializeStripe() {
      // Do not recreate elements if they already exist (preserve user input)
      if (this.cardNumber && this.cardExpiry && this.cardCvc) {
        return;
      }

      if (this.stripe) {
        this.configureStripe();
        return;
      }

      this.includeStripe('js.stripe.com/v3/', function(){
        this.configureStripe();
      }.bind(this));
    },

    includeStripe(URL, callback) {
      let documentTag = document, tag = 'script',
          object = documentTag.createElement(tag),
          scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = '//' + URL;
      if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
      scriptTag.parentNode.insertBefore(object, scriptTag);
    },

    configureStripe() {
      const style = {
        base: {
          color: 'black',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '14px',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: 'red',
          iconColor: 'red',
        },
      };

      if (!this.stripe) {
        this.stripe = Stripe(appConfig.stripePublicKey, {
          locale: 'en'
        });
      }

      // Avoid destroying and recreating elements if they already exist
      if (this.cardNumber || this.cardExpiry || this.cardCvc) {
        return;
      }

      let stripeEl = this.stripe.elements();
      this.cardNumber = stripeEl.create('cardNumber', { style });
      this.cardNumber.mount('#card-number');
      this.cardExpiry = stripeEl.create('cardExpiry', { style });
      this.cardExpiry.mount('#card-expiry');
      this.cardCvc = stripeEl.create('cardCvc', { style });
      this.cardCvc.mount('#card-cvc');
    },
    cleanupStripeElements() {
      if (this.cardNumber) {
        this.cardNumber.destroy();
        this.cardExpiry.destroy();
        this.cardCvc.destroy();
        this.cardNumber = null;
        this.cardExpiry = null;
        this.cardCvc = null;

        // Clean up Stripe iframes
        _.forEach(document.querySelectorAll('iframe'), el => {
          if (_.includes(el.src, 'js.stripe.com')) {
            el.parentNode.removeChild(el);
          }
        });
      }
    },
    clearCardError() {
      const cardError = document.getElementById('card-error');
      if (cardError) {
        cardError.innerHTML = '';
      }
    },
    selectPaymentMethod(method) {
      this.selectedPaymentMethod = method;

      if (method === 'new-card') {
        this.$nextTick(() => {
          if (!this.stripe) {
            this.initializeStripe();
          } else {
            // Remount elements if they were destroyed
            this.configureStripe();
          }
        });
      } else {
        // Clean up Stripe elements when switching to saved card
        this.cleanupStripeElements();
      }
    },
  },
  mounted() {
   // this.loadSavedCard();
  },
  beforeDestroy() {
    this.cleanupStripeElements();
  },
}
</script>

<template>
  <div>
    <transition name="slide">
      <div v-show="showDialog"
           @click.stop="hide"
           @keyup.esc="hide"
           tabindex="-1"
           role="dialog"
           :class="['modal', 'fade', { in: showDialog, 'display-block': showDialog, 'modal-last-step': stepModal == 1 }]"
           style="overflow: auto">
        <div v-show="stepModal == 0" @click.stop="" role="document" class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header-custom">
              <img src="../../assets/logos/logo-invoice.png" height="42" width="200"/>
              <button
                type="button"
                class="modal-close-btn"
                aria-label="Close"
                @click.stop="hide"
              >
                <i class="bx bx-x"></i>
              </button>
              <div class="header-title">
                Add credits to your account by paying online
              </div>
              <div class="header-info">
                <div>Save $20.00 on end of month processing and potential late
                  payment fees by purchasing credits online.</div>
                <div>Online payments are processed securely and receipts are
                  emailed directly to you after the transaction.</div>
              </div>
            </div>
            <div class="d-flex" style="height: 100%; justify-content: space-between">
              <div style="width: 50%">
                <div class="body-title" v-if="!isAiCopilotDamageDisabled">Assissted Estimate</div>
                <div class="body-table" v-if="!isAiCopilotDamageDisabled">
                  <div class="body-table-header">
                    <div class="body-table-header-item body-table-header-service">Service</div>
                    <div class="body-table-header-item body-table-header-qty">Qty</div>
                    <div class="body-table-header-item body-table-header-amount">Amount</div>
                    <div class="body-table-header-item body-table-header-add"></div>
                  </div>
                  <div class="body-table-body">
                    <div class="body-table-body-item" >
                      <div class="body-table-body-item-elem body-table-body-item-service">
                        Quick Estimate - Dollars Stnd
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-qty">
                        <number-formatter
                            style="width: 32px"
                            type="text"
                            v-model="creditQty.daDollarsStandard"
                            class="noselect form-control numeric numeric-qty"
                            format="0,0"></number-formatter>
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-amount">
                        $5.00
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-add">
                        <button class="btn btn-primary" style="background-color: rgb(94, 121, 255); color: white; width: 100px" @click="addToCart('daDollarsStandard')">Add to Cart</button>
                      </div>
                    </div>
                    <div class="body-table-body-item" >
                      <div class="body-table-body-item-elem body-table-body-item-service">
                       NTAR/LTAR - Standard
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-qty">
                        <number-formatter
                            style="width: 32px"
                            type="text"
                            v-model="creditQty.daNtarltarStandard"
                            class="noselect form-control numeric numeric-qty"
                            format="0,0"></number-formatter>
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-amount">
                        $5.00
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-add">
                        <button class="btn btn-primary" style="background-color: rgb(94, 121, 255); color: white; width: 100px" @click="addToCart('daNtarltarStandard')">Add to Cart</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="body-title" v-if="!isAiCopilotVehicleDisabled && !isPremiumPlan">Vehicle Identifier</div>
                <div class="body-table" v-if="!isAiCopilotVehicleDisabled && !isPremiumPlan">
                  <div class="body-table-header">
                    <div class="body-table-header-item body-table-header-service">Service</div>
                    <div class="body-table-header-item body-table-header-qty">Qty</div>
                    <div class="body-table-header-item body-table-header-amount">Amount</div>
                    <div class="body-table-header-item body-table-header-add"></div>
                  </div>
                  <div class="body-table-body">
                    <div class="body-table-body-item">
                      <div class="body-table-body-item-elem body-table-body-item-service">
                        Vehicle Identifier
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-qty">
                        <number-formatter
                            style="width: 32px"
                            type="text"
                            v-model="creditQty.viVehicleIdentification"
                            class="noselect form-control numeric numeric-qty"
                            format="0,0"></number-formatter>
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-amount">
                        $0.30
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-add">
                        <button class="btn btn-primary" style="background-color: rgb(94, 121, 255); color: white; width: 100px" @click="addToCart('viVehicleIdentification')">Add to Cart</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="body-title" v-if="!isAiCopilotPartsInfoDisabled && !isPremiumPlan">Parts Identifier</div>
                <div class="body-table" v-if="!isAiCopilotPartsInfoDisabled && !isPremiumPlan">
                  <div class="body-table-header">
                    <div class="body-table-header-item body-table-header-service">Service</div>
                    <div class="body-table-header-item body-table-header-qty">Qty</div>
                    <div class="body-table-header-item body-table-header-amount">Amount</div>
                    <div class="body-table-header-item body-table-header-add"></div>
                  </div>
                  <div class="body-table-body">
                    <div class="body-table-body-item">
                      <div class="body-table-body-item-elem body-table-body-item-service">
                        Parts Identifier
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-qty">
                        <number-formatter
                            style="width: 32px"
                            type="text"
                            v-model="creditQty.piPartIdentification"
                            class="noselect form-control numeric numeric-qty"
                            format="0,0"></number-formatter>
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-amount">
                        $0.10
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-add">
                        <button class="btn btn-primary" style="background-color: rgb(94, 121, 255); color: white; width: 100px" @click="addToCart('piPartIdentification')">Add to Cart</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 40%; margin-top: 26px">
                <div class="body-table-cart-summary">
                  <div class="body-table-header">
                    <div class="body-table-header-item body-table-header-service">Cart - Summary</div>
                    <div class="body-table-header-item body-table-header-qty"></div>
                    <div class="body-table-header-item body-table-header-amount-cart"></div>
                  </div>
                  <div class="body-table-body">
                    <div class="body-table-body-item" v-show="shouldShowCartItem('daDollarsStandard')">
                      <div class="body-table-body-item-elem body-table-body-item-service">
                        Quick Estimate - Dollars Stnd
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-qty">
                        <number-formatter
                            style="width: 32px"
                            type="text"
                            v-model="cartQty.daDollarsStandard"
                            class="noselect form-control numeric numeric-qty"
                            @onChange="onCartQtyChange('daDollarsStandard')"
                            @onFocus="onCartFocus('daDollarsStandard')"
                            @blur="onCartBlur"
                            format="0,0"></number-formatter>
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-amount-cart">
                        ${{truncate2Str(cartQty.daDollarsStandard * 5.00)}}
                      </div>
                    </div>
                    <div class="body-table-body-item" v-show="shouldShowCartItem('daNtarltarStandard')">
                      <div class="body-table-body-item-elem body-table-body-item-service">
                        NTAR/LTAR - Stnd
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-qty">
                        <number-formatter
                            style="width: 32px"
                            type="text"
                            v-model="cartQty.daNtarltarStandard"
                            class="noselect form-control numeric numeric-qty"
                            @onChange="onCartQtyChange('daNtarltarStandard')"
                            @onFocus="onCartFocus('daNtarltarStandard')"
                            @blur="onCartBlur"
                            format="0,0"></number-formatter>
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-amount-cart">
                        ${{truncate2Str(cartQty.daNtarltarStandard * 5.00)}}
                      </div>
                    </div>
                    <div class="body-table-body-item" v-show="shouldShowCartItem('viVehicleIdentification')">
                      <div class="body-table-body-item-elem body-table-body-item-service">
                        Vehicle Identifier
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-qty">
                        <number-formatter
                            style="width: 32px"
                            type="text"
                            v-model="cartQty.viVehicleIdentification"
                            class="noselect form-control numeric numeric-qty"
                            @onChange="onCartQtyChange('viVehicleIdentification')"
                            @onFocus="onCartFocus('viVehicleIdentification')"
                            @blur="onCartBlur"
                            format="0,0"></number-formatter>
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-amount-cart">
                        ${{ truncate2Str(cartQty.viVehicleIdentification * 0.30)}}
                      </div>
                    </div>
                     <div class="body-table-body-item" v-show="shouldShowCartItem('piPartIdentification')">
                      <div class="body-table-body-item-elem body-table-body-item-service">
                       Parts Identifier
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-qty">
                        <number-formatter
                            style="width: 32px"
                            type="text"
                            v-model="cartQty.piPartIdentification"
                            class="noselect form-control numeric numeric-qty"
                            @onChange="onCartQtyChange('piPartIdentification')"
                            @onFocus="onCartFocus('piPartIdentification')"
                            @blur="onCartBlur"
                            format="0,0"></number-formatter>
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-amount-cart">
                        ${{ truncate2Str(cartQty.piPartIdentification * 0.10)}}
                      </div>
                    </div>
                    <div class="body-table-body-item" style="border-bottom: 0;">
                      <div class="body-table-body-item-elem body-table-body-item-elem-total body-table-body-item-service" style="text-align: right">
                        Subtotal
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-elem-total body-table-body-item-amount-cart">
                        ${{subtotal}}
                      </div>
                    </div>
                    <div class="body-table-body-item">
                      <div class="body-table-body-item-elem body-table-body-item-elem-total body-table-body-item-service" style="text-align: right">
                        GST
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-elem-total body-table-body-item-amount-cart">
                        ${{gst}}
                      </div>
                    </div>
                    <div class="body-table-body-item">
                      <div class="body-table-body-item-elem body-table-body-item-elem-total body-table-body-item-service" style="text-align: right">
                        Total
                      </div>
                      <div class="body-table-body-item-elem body-table-body-item-elem-total body-table-body-item-amount-cart">
                        ${{total}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="separator-line"></div>
<!--                <div>-->
<!--                  <div class="body-title">Payment</div>-->
<!--                  <label for="credit-card" style="display: block">-->
<!--                    <div class="credit-card d-flex justify-content-between">-->
<!--                      <div style="position: relative; top: 3px; flex-grow: 1">-->
<!--                        <input class="credit-card-checkbox" id="credit-card" type="checkbox">-->
<!--                        <span class="credit-card-name">Credit / Debit Card</span>-->
<!--                      </div>-->
<!--                      <div class="credit-card-icons">-->
<!--                        <i class='bx bx-credit-card' ></i>-->
<!--                        <i class='bx bxl-mastercard' ></i>-->
<!--                        <i class='bx bxl-visa' ></i>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </label>-->
<!--                  <label for="saved-card" style="display: block">-->
<!--                    <div class="credit-card d-flex justify-content-between">-->
<!--                      <div style="position: relative; top: 3px; flex-grow: 1">-->
<!--                        <input class="credit-card-checkbox" id="saved-card" type="checkbox">-->
<!--                        <span class="credit-card-name" style="text-transform: none">Saved Card</span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </label>-->
<!--                  <div v-if="true" style="font-weight: 800; color: red; text-align: center; font-size: 11px; position: absolute; margin-left: 20px">-->
<!--                    No card details found. Enter details & save card details.-->
<!--                  </div>-->
<!--                  <div v-else style="font-weight: 800; color: #00ad00; text-align: center; font-size: 11px; position: absolute; margin-left: 20px">-->
<!--                    Card Saved. Ready to Use.-->
<!--                  </div>-->
<!--                  <div v-if="false" class="credit-card-date">-->
<!--                    <div class="credit-card-date-title">-->
<!--                        Credit / Debit Card-->
<!--                    </div>-->
<!--                    <div class="credit-card-date-item">-->
<!--                      <input-->
<!--                          type="text"-->
<!--                          class="form-control"-->
<!--                          placeholder="CARD NUMBER"/>-->
<!--                    </div>-->
<!--                    <div class="d-flex credit-card-date-item justify-content-between">-->
<!--                      <div style="width: 40%">-->
<!--                        <input-->
<!--                            type="text"-->
<!--                            class="form-control"-->
<!--                            placeholder="Expiry MM/YY"/>-->
<!--                      </div>-->
<!--                      <div style="width: 30%">-->
<!--                        <input-->
<!--                            type="text"-->
<!--                            class="form-control"-->
<!--                            placeholder="CCV"/>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="credit-card-date-save">-->
<!--                      <label for="save-card" class="form-check-inline checkbox" style="display: block">-->
<!--                          <span style="font-weight: 700; position: relative; top: 3px">Save Card</span>-->
<!--                          <input class="form-check-input" type="checkbox" id="save-card">-->
<!--                          <span class="icon" style="float: right; margin-right: 0"><i class='bx bx-check'></i></span>-->
<!--                      </label>-->
<!--                    </div>-->
<!--                    <div class="credit-card-date-footer d-flex">-->
<!--                      <div style="position: relative; top: 4px">-->
<!--                        Secured Payments-->
<!--                      </div>-->
<!--                      <div class="credit-card-date-footer-stripe">-->
<!--                        Powered by <span>stripe</span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div v-else class="credit-card-date credit-card-date-saved">-->
<!--                    <div class="credit-card-date-title credit-card-date-title-saved">-->
<!--                      Credit / Debit Card-->
<!--                    </div>-->
<!--                    <div class="credit-card-date-item" style="font-weight: 700">-->
<!--                      VISA-->
<!--                    </div>-->
<!--                    <div class="credit-card-date-item">-->
<!--                      <div>-->
<!--                        Card Number: ...6578-->
<!--                      </div>-->
<!--                      <div style="margin-top: 15px">-->
<!--                        Expiration Date: 07/28-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="credit-card-date-footer-saved">-->
<!--                      <div>-->
<!--                        Secured Payments-->
<!--                      </div>-->
<!--                      <div class="credit-card-date-footer-saved-remove">-->
<!--                        Remove-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div>-->
<!--                    <button class="btn btn-primary-yellow"><i class='bx bxs-lock-alt'></i> Place Ordered</button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--                <div>-->
<!--                  <div class="body-title">Payment</div>-->

<!--                  &lt;!&ndash; Payment Method Selection &ndash;&gt;-->
<!--                  <label for="credit-card" style="display: block">-->
<!--                    <div class="credit-card d-flex justify-content-between"-->
<!--                         :class="{ 'selected': selectedPaymentMethod === 'new-card' }"-->
<!--                         @click="selectPaymentMethod('new-card')">-->
<!--                      <div style="position: relative; top: 3px; flex-grow: 1">-->
<!--                        <input class="credit-card-checkbox" id="credit-card" type="radio"-->
<!--                               :checked="selectedPaymentMethod === 'new-card'">-->
<!--                        <span class="credit-card-name">Credit / Debit Card</span>-->
<!--                      </div>-->
<!--                      <div class="credit-card-icons">-->
<!--                        <i class='bx bx-credit-card'></i>-->
<!--                        <i class='bx bxl-mastercard'></i>-->
<!--                        <i class='bx bxl-visa'></i>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </label>-->

<!--                  <label for="saved-card" style="display: block">-->
<!--                    <div class="credit-card d-flex justify-content-between"-->
<!--                         :class="{ 'selected': selectedPaymentMethod === 'saved-card' }"-->
<!--                         @click="selectPaymentMethod('saved-card')">-->
<!--                      <div style="position: relative; top: 3px; flex-grow: 1">-->
<!--                        <input class="credit-card-checkbox" id="saved-card" type="radio"-->
<!--                               :checked="selectedPaymentMethod === 'saved-card'">-->
<!--                        <span class="credit-card-name" style="text-transform: none">Saved Card</span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </label>-->

<!--                  &lt;!&ndash; Saved Card Status &ndash;&gt;-->
<!--                  <div v-if="!hasSavedCard" style="font-weight: 800; color: red; text-align: center; font-size: 11px; position: absolute; margin-left: 20px">-->
<!--                    No card details found. Enter details & save card details.-->
<!--                  </div>-->
<!--                  <div v-else style="font-weight: 800; color: #00ad00; text-align: center; font-size: 11px; position: absolute; margin-left: 20px">-->
<!--                    Card Saved. Ready to Use.-->
<!--                  </div>-->

<!--                  &lt;!&ndash; New Card Form &ndash;&gt;-->
<!--                  <div v-if="selectedPaymentMethod === 'new-card'" class="credit-card-date">-->
<!--                    <div class="credit-card-date-title">-->
<!--                      Credit / Debit Card-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Stripe Card Number Element &ndash;&gt;-->
<!--                    <div class="credit-card-date-item">-->
<!--                      <div class="card-field" id="card-number"></div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Stripe Expiry and CVC Elements &ndash;&gt;-->
<!--                    <div class="d-flex credit-card-date-item justify-content-between">-->
<!--                      <div style="width: 40%">-->
<!--                        <div class="card-field" id="card-expiry"></div>-->
<!--                      </div>-->
<!--                      <div style="width: 30%">-->
<!--                        <div class="card-field" id="card-cvc"></div>-->
<!--                      </div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Save Card Option &ndash;&gt;-->
<!--                    <div class="credit-card-date-save">-->
<!--                      <label for="save-card" class="form-check-inline checkbox" style="display: block">-->
<!--                        <span style="font-weight: 700; position: relative; top: 3px">Save Card</span>-->
<!--                        <input class="form-check-input" type="checkbox" id="save-card" v-model="saveCard">-->
<!--                        <span class="icon" style="float: right; margin-right: 0"><i class='bx bx-check'></i></span>-->
<!--                      </label>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Processing Fee Info &ndash;&gt;-->
<!--                    <div style="margin: 10px 0; font-size: 12px; color: #666;">-->
<!--                      Processing fee: 1.75% + 30c (Total: ${{ totalWithFee.toFixed(2) }})-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Error Display &ndash;&gt;-->
<!--                    <div style="margin-left: 15px; margin-top: 10px">-->
<!--                      <div id="card-error" style="color: red;"></div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Footer &ndash;&gt;-->
<!--                    <div class="credit-card-date-footer d-flex">-->
<!--                      <div style="position: relative; top: 4px">-->
<!--                        Secured Payments-->
<!--                      </div>-->
<!--                      <div class="credit-card-date-footer-stripe">-->
<!--                        Powered by <span>stripe</span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                  &lt;!&ndash; Saved Card Display &ndash;&gt;-->
<!--                  <div v-else-if="selectedPaymentMethod === 'saved-card' && hasSavedCard" class="credit-card-date credit-card-date-saved">-->
<!--                    <div class="credit-card-date-title credit-card-date-title-saved">-->
<!--                      Credit / Debit Card-->
<!--                    </div>-->
<!--                    <div class="credit-card-date-item" style="font-weight: 700">-->
<!--                      {{ savedCard.brand.toUpperCase() }}-->
<!--                    </div>-->
<!--                    <div class="credit-card-date-item">-->
<!--                      <div>-->
<!--                        Card Number: ...{{ savedCard.last4 }}-->
<!--                      </div>-->
<!--                      <div style="margin-top: 15px">-->
<!--                        Expiration Date: {{ String(savedCard.expMonth).padStart(2, '0') }}/{{ savedCard.expYear.toString().substr(-2) }}-->
<!--                      </div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Processing Fee Info &ndash;&gt;-->
<!--                    <div style="margin: 10px 0; font-size: 12px; color: #666;">-->
<!--                      Processing fee: 1.75% + 30c (Total: ${{ totalWithFee.toFixed(2) }})-->
<!--                    </div>-->

<!--                    <div class="credit-card-date-footer-saved">-->
<!--                      <div>-->
<!--                        Secured Payments-->
<!--                      </div>-->
<!--                      <div class="credit-card-date-footer-saved-remove"-->
<!--                           @click="removeSavedCard"-->
<!--                           style="cursor: pointer; color: #dc3545;">-->
<!--                        Remove-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                  &lt;!&ndash; No Saved Card Available &ndash;&gt;-->
<!--                  <div v-else-if="selectedPaymentMethod === 'saved-card' && !hasSavedCard" class="credit-card-date credit-card-date-saved">-->
<!--                    <div class="credit-card-date-title credit-card-date-title-saved">-->
<!--                      No Saved Card-->
<!--                    </div>-->
<!--                    <div class="credit-card-date-item" style="text-align: center; color: #666; padding: 20px;">-->
<!--                      No saved card available. Please select "Credit / Debit Card" to enter new card details.-->
<!--                    </div>-->
<!--                  </div>-->

<!--                  &lt;!&ndash; Payment Button &ndash;&gt;-->
<!--                  <div style="margin-top: 20px;">-->
<!--                    <button class="btn btn-primary-yellow"-->
<!--                            :disabled="disabled || (selectedPaymentMethod === 'saved-card' && !hasSavedCard)"-->
<!--                            @click="processPayment">-->
<!--                      <i class='bx bxs-lock-alt'></i>-->
<!--                      <span v-if="disabled">Processing...</span>-->
<!--                      <span v-else>Place Order ${{ totalWithFee.toFixed(2) }}</span>-->
<!--                    </button>-->
<!--                  </div>-->
<!--                </div>-->
                <div>
                  <div class="body-title">Payment</div>

                  <!-- Saved Card Info at Top (if exists) -->
                  <div class="saved-cards-section" style="margin-bottom: 5px;">
                    <div style="font-size: 12px; font-weight: 700; color: #666; margin-bottom: 5px;">
                      Your Saved Cards
                    </div>

                    <!-- Loop through saved cards -->
                    <div v-for="card in stripeCards"
                         :key="card.id"
                         class="saved-card-item"
                         :class="{ 'saved-card-selected': selectedPaymentMethod === 'saved-card' && selectedCardId === card.payment_method_id }"
                         style="display: flex; justify-content: space-between; align-items: center; padding: 12px 15px; border: 2px solid #e0e0e0; border-radius: 5px; margin-bottom: 5px; cursor: pointer; transition: all 0.2s;"
                         @click="useSavedCard(card.payment_method_id)">
                      <div style="display: flex; align-items: center;">
                        <div style="margin-right: 12px;">
                          <i v-if="card.brand.toLowerCase() === 'visa'" class='bx bxl-visa' style="font-size: 32px; color: #1332c3;"></i>
                          <i v-else-if="card.brand.toLowerCase() === 'mastercard'" class='bx bxl-mastercard' style="font-size: 28px; color: #f55600;"></i>
                          <i v-else class='bx bx-credit-card' style="font-size: 24px; color: #666;"></i>
                        </div>
                        <div>
                          <div style="font-weight: 700; font-size: 13px; color: #333;">
                            {{ card.brand.toUpperCase() }} •••• {{ card.last4 }}
                          </div>
                          <div style="font-size: 11px; color: #666; margin-top: 2px;">
                            Expires: {{ card.expiry }}
                            <span v-if="card.is_default" style="color: #5d78fd; font-weight: 700; margin-left: 8px;">Default</span>
                          </div>
                        </div>
                      </div>
                      <div style="display: flex; align-items: center;">
                        <!-- Selected indicator -->
                        <div
                            class="radio-pill"
                            :class="{ 'radio-pill--selected': card.is_default }"
                            @click.stop="setDefaultCard(card.payment_method_id)"
                            role="button"
                            aria-label="Select this card">
                          <i v-if="card.is_default"
                             class='bx bx-check radio-pill-check'></i>
                          <span v-else class="radio-pill-dot"></span>
                        </div>
                        <!-- Remove button -->
                        <button @click.stop="confirmRemoveSavedCard(card.payment_method_id)"
                                class="btn btn-sm saved-card-delete-btn"
                                title="Remove card">
                          <i class='bx bx-trash'></i>
                        </button>
                      </div>
                    </div>

                    <!-- Use New Card Option -->
                    <div class="new-card-option"
                         :class="{ 'saved-card-selected': selectedPaymentMethod === 'new-card' }"
                         style="display: flex; align-items: center; padding: 12px 15px; border: 2px solid #e0e0e0; border-radius: 5px; cursor: pointer; transition: all 0.2s;"
                         @click="selectPaymentMethod('new-card')">
                      <div>
                        <i class='bx bx-plus' style="font-size: 18px; margin-right: 8px; margin-top:2px; color: #5d78fd;"></i>
                        <span style="font-weight: 700; font-size: 13px; color: #333;">Use a New Card</span>
                      </div>
                    </div>
                  </div>
                  <!-- Stripe Card Form -->
                  <!-- Stripe Card Form (show when new-card selected OR no saved cards) -->
                  <div v-show="selectedPaymentMethod === 'new-card' || !hasSavedCards" class="credit-card-date">
                    <!-- Stripe Card Number Element -->
                    <div class="credit-card-date-item">
                      <label style="font-size: 11px; font-weight: 700; color: #666; margin-bottom: 5px; display: block;">
                        Card Number
                      </label>
                      <div class="card-field" id="card-number"></div>
                    </div>

                    <!-- Stripe Expiry and CVC Elements -->
                    <div class="d-flex credit-card-date-item justify-content-between">
                      <div style="width: 48%">
                        <label style="font-size: 11px; font-weight: 700; color: #666; margin-bottom: 5px; display: block;">
                          Expiry Date
                        </label>
                        <div class="card-field" id="card-expiry"></div>
                      </div>
                      <div style="width: 48%">
                        <label style="font-size: 11px; font-weight: 700; color: #666; margin-bottom: 5px; display: block;">
                          CVC
                        </label>
                        <div class="card-field" id="card-cvc"></div>
                      </div>
                    </div>

                    <!-- Save Card Option -->
                    <div class="credit-card-date-save">
                      <label for="save-card" class="form-check-inline checkbox" style="display: block">
                        <span style="font-weight: 700; position: relative; top: 3px">Save Card for Future Payments</span>
                        <input class="form-check-input" type="checkbox" id="save-card" v-model="saveCard">
                        <span class="icon" style="float: right; margin-right: 0; right: -15px; position: absolute;">
          <i class='bx bx-check'></i>
        </span>
                      </label>
                    </div>

                    <!-- Error Display -->
                    <div style="margin-top: 10px; margin-bottom: 10px">
                      <div id="card-error" style="color: red; font-size: 12px; font-weight: 600;"></div>
                    </div>
                  </div>

                  <!-- Selected Saved Card Summary (when saved card is selected) -->
                  <!-- <div v-if="selectedPaymentMethod === 'saved-card' && selectedCard"
                       style="background-color: #f8f9ff; border: 2px solid #5d78fd; border-radius: 5px; padding: 15px; margin-top: 5px;">
                    <div style="font-size: 12px; color: #666; margin-bottom: 5px;">Paying with:</div>
                    <div style="font-weight: 700; color: #5d78fd; font-size: 14px;">
                      <i class='bx bx-credit-card' style="font-size: 18px; position: relative; top: 3px; margin-right: 5px;"></i>
                      {{ selectedCard.brand.toUpperCase() }} •••• {{ selectedCard.last4 }}
                    </div>
                  </div> -->
                  <!-- Footer -->
                  <div class="credit-card-date-footer d-flex" style="margin-top: 5px;">
                    <div style="position: relative; top: 4px">
                      <i class='bx bx-lock-alt' style="font-size: 14px; margin-right: 3px;"></i>
                      Secured Payments
                    </div>
                    <div class="credit-card-date-footer-stripe">
                      Powered by <span>stripe</span>
                    </div>
                  </div>
                  <!-- Payment Button -->
                  <div>
                    <button class="btn btn-primary-yellow"
                            :disabled="(total == '0.00') || (disabled || (selectedPaymentMethod === 'saved-card' && !selectedCard))"
                            @click="processPayment"
                            style="width: 100%; font-size: 15px; padding: 12px;">
                      <i class='bx bxs-lock-alt'></i>
                      <span v-if="disabled">Processing Payment...</span>
                      <span v-else>Pay ${{ total }}</span>
                    </button>
                  </div>
                </div>
                </div>
            </div>
          </div>
        </div>
        <div v-if="stepModal == 1" @click.stop="" role="document" class="modal-dialog modal-lg">
          <div v-if="statusPaid" class="modal-content">
            <div>
              <div style="font-weight: 800; color: #00ad00; text-align: center; font-size: 15px">
                Payment Successful
              </div>
              <div style="margin-top: 15px; text-align: center; font-size: 14px">
                <div>
                  Congratulations, your transaction has completed and was successfully completed.
                </div>
                <div style="margin-top: 15px">
                  A receipt has been emailed to your emails address.
                </div>
              </div>
            </div>
          </div>
          <div v-else class="modal-content">
            <div>
              <div style="font-weight: 800; color: red; text-align: center; font-size: 15px">
                Payment Unsuccessful
              </div>
              <div style="margin-top: 15px; text-align: center; font-size: 14px">
                <div>
                  {{ stripeErrorText }}
                </div>
                <div style="margin-top: 15px">
                  An email has been sent to the Support team for further assistance.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showDialog" class="modal-backdrop fade in"></div>
    </transition>
  </div>
</template>

<style scoped>
.modal{
  top: 3% !important;
  scrollbar-width: thin;
}
.modal-last-step{
  top: 16% !important;
}
.modal-last-step .modal-dialog{
  width: 350px;
}
.modal-content{
  padding: 20px;
  border-radius: 5px;
}
.modal-header-custom{
  position: relative;
}
.modal-close-btn{
  position: absolute;
  top: -6px;
  right: -6px;
  border: 0;
  background: transparent;
  padding: 4px;
  line-height: 1;
  color: #1C1F39;
}
.modal-close-btn .bx{
  font-size: 28px;
}
.modal-close-btn:hover{
  color: #5d78fd;
}
.header-title{
  color: #5d78fd;
  border: 1px solid #5d78fd;
  border-radius: 4px;
  padding: 5px 15px;
  font-weight: 800;
  font-size: 15px;
  margin-top: 10px;
}
.header-info{
  background-color: #f0f0f0;
  padding: 7px 15px;
  border-radius: 4px;
  margin-top: 10px;
}

.body-table{
  min-width: 429px;
  overflow: hidden;
}
.body-table-header,
.body-table-body-item{
  display: flex;
}
.body-table-header{
  background-color: rgba(27, 30, 56, .1) !important;
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
}
.body-table-header-item,
.body-table-body-item-elem{
  padding: 0.75rem;
}
.body-title{
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  margin: 5px 0;
}

.body-table-body{
  font-weight: 700;
}
.body-table-body-item{
  border: 1px solid rgba(27, 30, 56, 0.15);
  border-top: 0;
}
.body-table-header-service,
.body-table-body-item-service{
  min-width: 170px;
  flex-grow: 1;
}

.body-table-header-amount,
.body-table-body-item-amount{
  min-width: 70px;
}
.body-table-header-amount-cart,
.body-table-body-item-amount-cart{
  min-width: 90px;
}
.body-table-body-item-amount,
.body-table-body-item-amount-cart{
  align-self: center;
}

.body-table-header-qty,
.body-table-body-item-qty{
  min-width: 50px;
}
.body-table-body-item-qty input{
  padding: .7rem .15rem;
  text-align: center;
}

.body-table-body-item-qty{
  align-self: center;
}

.body-table-header-qty{
  text-align: center;
}

.body-table-header-add,
.body-table-body-item-add{
  min-width: 120px;
}

.body-table-body-item-add{
  align-self: center;
}

.body-table-cart-summary{
  min-width: auto;
}
.body-table-cart-summary .body-table-body-item{
  border-left: 0;
  border-right: 0;
}

.body-table-body-item-elem-total{
  padding-top: 2px;
  padding-bottom: 2px;
}
.separator-line{
  margin-top: 5px;
  margin-bottom: 5px;
  height: 5px;
  border-radius: 999px;
  background-color: #d7d7d7;
}
.credit-card-checkbox{
  appearance: none;
  position: relative;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(27, 30, 56, 0.25);
  cursor: pointer;
}
.credit-card-checkbox:hover{
  background-color: #f5f5f5;
}
.credit-card-checkbox:checked{
  background-color: #5d78fd;
}
.credit-card{
  border: 2px solid rgba(27, 30, 56, 0.15);
  border-radius: 2px;
  padding: 5px 15px;
  height: 40px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  cursor: pointer;
}
.credit-card-name{
  text-transform: uppercase;
  font-weight: 700;
  position: relative;
  bottom: 5px;
  margin-left: 10px
}
.credit-card-icons{
  position: relative;
  bottom: 7px;
}
.credit-card-icons .bx{
  font-size: 23px;
  margin-left: 3px;
  margin-right: 3px;
  color: #498422;
}
.credit-card-icons .bxl-mastercard{
  font-size: 25px;
  position: relative;
  top: 1px;
  color: #f55600;
  margin-left: 7px;
}
.credit-card-icons .bxl-visa{
  font-size: 32px;
  position: relative;
  top: 4px;
  color: #1332c3;
}
.credit-card-date{
  border: 2px solid rgba(27, 30, 56, 0.15);
  border-radius: 5px;
  padding: 5px 15px;
}
.credit-card-date-saved{
  background-color: #f0f0f0;
}
.credit-card-date-title{
  text-transform: uppercase;
  font-weight: 700;
}
.credit-card-date-title-saved{
  color: #5d78fd;
  font-weight: 900;
}
.credit-card-date-item{
  margin-top: 5px;
}
.credit-card-date-save{
  width: 72%;
  margin-top: 15px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  cursor: pointer;
}
.credit-card-date-footer{
  justify-content: flex-end;
  margin-top: 15px;
  color: #5f57f5;
  font-weight: 900;
  font-size: 12px;
}
.credit-card-date-footer-stripe{
  margin-left: 10px;
  border: 1px solid #5f57f5;
  border-radius: 5px;
  padding: 0 7px;
  font-weight: 500;
}
.credit-card-date-footer-stripe span{
  font-weight: 900;
  font-size: 16px;
}
.credit-card-date-footer-saved{
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  color: #5f57f5;
  font-weight: 900;
  font-size: 12px;
}
.credit-card-date-footer-saved-remove{
  color: red;
  font-size: 13px;
  cursor: pointer;
}
.btn-primary-yellow{
  background-color: rgb(253, 190, 0);
  color: black;
  font-weight: 900;
  border-radius: 3px;
  text-transform: uppercase;
  float: right;
  margin-top: 10px;
}
.btn-primary-yellow:hover{
  background-color: rgb(231, 172, 1);
}
.btn-primary-yellow .bx{
  margin-right: 7px;
  font-size: 15px;
  color: #717171;
}
/* Stripe Elements Styles */
.card-field {
  height: 38px;
  box-sizing: border-box;
  border: 1px solid rgba(28, 31, 57, 0.25);
  background-clip: padding-box;
  border-radius: 3px;
  color: #1C1F39;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  display: block;
  width: 100%;
  background-color: #FFFFFF;
  padding-top:  10px;
  padding-left: 10px;
}
#card-error {
  color: red;
}
/* Add selected state for payment method */
.credit-card.selected{
  border-color: #5d78fd;
  background-color: #f8f9ff;
}
/* Saved Cards Styles */
.saved-card-item:hover,
.new-card-option:hover {
  border-color: #5d78fd !important;
  background-color: #fafbff;
}

.saved-card-selected {
  border-color: #5d78fd !important;
  background-color: #f8f9ff !important;
}
.radio-pill {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ccc;
  margin-right: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color .15s, background-color .15s;
}
.radio-pill-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: transparent;
}
.radio-pill-check {
  font-size: 14px;
  color: white;
  line-height: 1;
}
.radio-pill--selected {
  border-color: #5d78fd;
  background-color: #5d78fd;
}
.radio-pill--selected .radio-pill-dot {
  background-color: #5d78fd;
}
.saved-card-delete-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  background-color: #dc3545;
  border: none;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.saved-card-delete-btn:hover {
  background-color: #c82333;
}

.saved-card-delete-btn i {
  color: white;
  font-size: 16px;
}
</style>
